module.exports = __webpack_public_path__ + "img/c.21c7de0a.jpg";